import { FieldDataNode } from "rc-tree";
import { SvgStatusError } from "@itwin/itwinui-icons-react";
import { Button, Dialog, Flex, Icon } from "@itwin/itwinui-react";
import { ExplorerDataNode, getNestedNodes } from "../treeDataManipulation";
import styles from "./DeleteDialog.module.css";

interface DeleteDialogOptions {
  isOpen: boolean;
  onClose: (filePath?: string[]) => void;
  targetNode: FieldDataNode<ExplorerDataNode>[]
}

export const DeleteDialog = ({ isOpen, onClose, targetNode }: DeleteDialogOptions) => {

  if (!isOpen) return null;

  return (
    <Dialog isOpen={isOpen} onClose={() => onClose()} closeOnEsc closeOnExternalClick preventDocumentScroll trapFocus setFocus isDismissible>
      <Dialog.Backdrop />
      <Dialog.Main className={styles.deleteDialog}>
        <Dialog.Content>
          <Flex gap="m" >
            <Icon fill="negative" size="large">
              <SvgStatusError />
            </Icon>
            <div>
              {targetNode.length === 1 && <div>Are you sure to delete {targetNode[0].isLeaf ? "file" : "folder"} "{targetNode[0].title}"?</div>}
              {targetNode.length > 1 && <div>Are you sure to delete selected files?</div>}
              <div>This action is not reversible</div>
            </div>
          </Flex>
        </Dialog.Content>
        <Dialog.ButtonBar>
          <Button styleType="high-visibility" onClick={() => onClose(targetNode.flatMap((item) => getNestedNodes(item)).map((item) => item.key))}>Delete</Button>
          <Button onClick={() => onClose()}>Cancel</Button>
        </Dialog.ButtonBar>
      </Dialog.Main>
    </Dialog >
  )
};